import React, { useEffect, useRef, useState } from 'react';
import './HumanCentricSection.css';

const tabs = [
  { id: 'about', label: 'About Us' },
  { id: 'perks', label: 'Perks' },
  { id: 'values', label: 'Our Values' },
  { id: 'positions', label: 'Open Positions' },
  { id: 'selection', label: 'Selection Process' },
];

const HumanCentricSection = () => {
  const [activeTab, setActiveTab] = useState('about');
  const frontRef = useRef(null);
  const middleRef = useRef(null);
  const backRef = useRef(null);
  const navbarRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile) return; // Skip animation setup on mobile

    const handleScroll = () => {
      const offset = window.scrollY;
      if (frontRef.current) {
        frontRef.current.style.transform = `translateY(${offset * 0.2}px)`;
      }
      if (middleRef.current) {
        middleRef.current.style.transform = `translateY(${offset * 0.1}px)`;
      }
      if (backRef.current) {
        backRef.current.style.transform = `translateY(${offset * 0.05}px)`;
      }

      const currentNavbarHeight = navbarRef.current ? navbarRef.current.offsetHeight : 0;
      const scrollOffset = currentNavbarHeight + 20;

      let foundActive = false;
      for (let i = tabs.length - 1; i >= 0; i--) {
        const tabId = tabs[i].id;
        const section = document.getElementById(tabId);
        if (section && section.offsetTop <= window.scrollY + scrollOffset) {
          setActiveTab(tabId);
          foundActive = true;
          break;
        }
      }
      if (!foundActive) {
        setActiveTab(tabs[0].id);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  const handleTabClick = (id) => {
    setActiveTab(id);
    const section = document.getElementById(id);
    if (section && navbarRef.current) {
      const currentNavbarHeight = navbarRef.current.offsetHeight;
      window.scrollTo({
        top: section.offsetTop - currentNavbarHeight,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <nav className="hc-navbar" ref={navbarRef}>
        <ul>
          {tabs.map((tab) => (
            <li
              key={tab.id}
              className={activeTab === tab.id ? 'active' : ''}
            >
              <a onClick={() => handleTabClick(tab.id)}>
                {tab.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      
      <section className="human-centric-section" id="about">
        <div className="container">
          <h2 className="hc-title">WE ARE<br/> <span>HUMAN-CENTRIC</span></h2>
          <div className="hc-illustration">
            <img 
              ref={middleRef} 
              className="hc-middle" 
              src="/front2.svg" 
              alt="Chair Layer" 
              style={isMobile ? { transform: 'none !important' } : {}} 
            />
            <img 
              ref={frontRef} 
              className="hc-front" 
              src="/front1.svg" 
              alt="Human Layer" 
              style={isMobile ? { transform: 'none !important' } : {}} 
            />
          </div>
          <div className="hc-main">
            <div className="hc-content">
              <p className="hc-quote">
                "When people are at their best, <strong>they do their best work</strong>"
              </p>
              <p className="hc-desc">
                At Lattice Labs, we do things differently than other companies. We value the human factor because we know that when you succeed, you'll make Imaginary Cloud grow. So we hire the best and offer them the resources they need to thrive. This way, we succeed in living up to our vision to become the leading company and employer championing <br />
                <span className="highlight">a human-centric world.</span>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HumanCentricSection;